import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	marginBlockStart: token('space.300'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentWrapper = styled.div<{ hasContent: boolean }>(
	{
		paddingInline: token('space.100'),
		marginBlockEnd: token('space.150'),
		overflowY: 'hidden',
		display: 'flex',
		flexDirection: 'column',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ hasContent }) =>
		hasContent && {
			marginBlockStart: token('space.150'),
		},
);
